import { Link } from '@/lib/nav';
import { ROUTES } from '@/lib/routes';

export function Footer() {
  return (
    <footer className="mt-24 border-t border-line bg-paper-tinted/40">
      <div className="container py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <FooterColumn title="Producto">
            <FooterLink to={ROUTES.producto.index}>Qué es SICA</FooterLink>
            <FooterLink to={ROUTES.producto.jurisdicciones}>Jurisdicciones</FooterLink>
            <FooterLink to={ROUTES.producto.metodo}>Método</FooterLink>
            <FooterLink to={ROUTES.producto.mcp}>MCP</FooterLink>
          </FooterColumn>
          <FooterColumn title="Audiencias">
            <FooterLink to={ROUTES.audiencias.docentes}>Docentes</FooterLink>
            <FooterLink to={ROUTES.audiencias.directivos}>Directivos</FooterLink>
            <FooterLink to={ROUTES.audiencias.especialistas}>Especialistas</FooterLink>
            <FooterLink to={ROUTES.audiencias.desarrolladores}>Desarrolladores</FooterLink>
          </FooterColumn>
          <FooterColumn title="SICA">
            <FooterLink to={ROUTES.sobre}>Sobre SICA</FooterLink>
            <FooterLink to={ROUTES.glosario}>Glosario</FooterLink>
            <FooterLink to={ROUTES.contacto}>Contacto</FooterLink>
          </FooterColumn>
          <FooterColumn title="Legal y editorial">
            <FooterLink to={`${ROUTES.legal}#terminos`}>Términos</FooterLink>
            <FooterLink to={`${ROUTES.legal}#privacidad`}>Privacidad</FooterLink>
            <FooterLink to={`${ROUTES.legal}#politica-de-fuentes`}>Política de fuentes</FooterLink>
            <p className="mt-4 text-xs leading-relaxed text-ink-muted">
              Editor responsable: <span className="text-ink">Editorial Estrada</span> (1869).
            </p>
          </FooterColumn>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-line pt-8 text-xs text-ink-muted md:flex-row md:items-center">
          <p>
            © {new Date().getFullYear()} SICA · Sistema Inteligente Curricular Argentino.
          </p>
          <p>
            Inteligencia curricular validada · Cita exacta o nada.
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="mb-4 text-xs font-semibold uppercase tracking-wider text-ink">
        {title}
      </h2>
      <ul className="flex flex-col gap-2">{children}</ul>
    </div>
  );
}

function FooterLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <li>
      <Link
        to={to}
        className="focus-ring rounded text-sm text-ink-muted transition-colors hover:text-ink"
      >
        {children}
      </Link>
    </li>
  );
}
